import type { VisibleIfClause } from "./flexibleSurveyTypes";

function getList(v: unknown): string[] {
  return Array.isArray(v) && v.every((x) => typeof x === "string")
    ? (v as string[])
    : [];
}

export function evalVisibleIf(
  clause: VisibleIfClause | undefined,
  values: Record<string, unknown>,
): boolean {
  if (!clause) return true;
  if ("all" in clause && Array.isArray(clause.all)) {
    return clause.all.every((c) => evalVisibleIf(c, values));
  }
  if ("any" in clause && Array.isArray(clause.any)) {
    return clause.any.some((c) => evalVisibleIf(c, values));
  }
  if (!("field" in clause) || !("op" in clause)) return true;
  const raw = values[clause.field];
  if (clause.op === "eq") {
    return typeof raw === "string" && raw === clause.value;
  }
  if (clause.op === "neq") {
    return typeof raw !== "string" || raw !== clause.value;
  }
  const list = getList(raw);
  if (clause.op === "includes") return list.includes(clause.value);
  if (clause.op === "not_includes") return !list.includes(clause.value);
  return true;
}
